<cc-section class="p-t-5-important">
  <cc-choose-plan></cc-choose-plan>
  <cc-card *ngIf="(card$ | async)?.brand" [card]="card$ | async"></cc-card>
</cc-section>
